
<template>
  <div class="mobile-menu mt-3">
    <v-app-bar-nav-icon @click="dialog = true"></v-app-bar-nav-icon>

    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-left-transition"
    >
      <div
        style="background-color: #1a2942; height: 100%; width: 260px"
      >
        <v-row>
          <v-col cols="9">
            <div class="logo logo-light mt-2">
              <img :src="JciLogo" alt="jci-logo" height="80" width="80" />
            </div>
          </v-col>
          <v-col cols="2">
            <v-icon
              class="white--text text-center mt-4"
              large
              @click="dialog = false"
            >
              mdi-close
            </v-icon>
          </v-col>
        </v-row>
        <!-- Sidebar -left -->
        <div class="h-100" id="leftside-menu-container">
          <menu-lists :dialog="dialog" @hideMenuDialog="hideMenuDialog" />
        </div>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import MenuLists from "@/components/MenuLists.vue";
import companyConfig from "@/company_config.json";

export default {
  components: {
    MenuLists,
  },
  data() {
    return {
      dialog: false,
      JciLogo: "",

      // drawer: false,
      // group: null,
    };
  },
  methods: {
    refreshPageData() {
      console.log("refreshPageData called");
      var server_url = companyConfig.apiURL;
      console.log({ server_url });

      var jci_logo = server_url + "assets/images/logo.png";
      console.log({ jci_logo });

      this.JciLogo = jci_logo;
    },
    hideMenuDialog(flag) {
      console.log("hideMenuDialog called");
      console.log({ flag });
      this.dialog = flag;
    },
  },
  beforeMount() {
    console.log("beforeMount called");
    this.refreshPageData();
  },
};
</script>
    
<style lang="scss" scoped>
.mobile-menu {
  .sidebar-menu {
    // background-color: #1a2942;
    // padding-bottom: 1000px;
  }
}
</style>
